import {IRegistration} from "../../store/registrations/interfaces";
import {IProgram} from "../../store/program/interfaces";

const check = (program: IProgram, registrations: IRegistration[]) =>
    registrations.reduce((acc, reg) => acc + reg.price, 0) === 0 ||
    !program.payment_configuration.enabled ||
    (!program.payment_configuration.cash.enabled &&
        !program.payment_configuration.transfer.enabled &&
        !program.payment_configuration.debit.enabled &&
        !program.payment_configuration.online.enabled &&
        !program.payment_configuration.custom.enabled &&
        !program.payment_configuration.invoice.enabled)
export default check
